"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const isEqual = require("lodash/isEqual"),
  /**
   * Check to see if an object is a valid JSON object
   *
   * @name isJsonFromObject
   * @param {object} obj Object to check for JSON compliance
   * @returns {boolean} Indicator whether test object is parsable as JSON
   */
  isJsonFromObject = obj => {
    let compareObj;
    try {
      compareObj = JSON.parse(JSON.stringify(obj));
    } catch (e) {
      compareObj = null;
    }
    return obj !== null && isEqual(obj, compareObj);
  };
var _default = exports.default = isJsonFromObject;